import { render, staticRenderFns } from "./takeoutSideboardOrderSchoolCount.vue?vue&type=template&id=12c25720&scoped=true&"
import script from "./takeoutSideboardOrderSchoolCount.vue?vue&type=script&lang=js&"
export * from "./takeoutSideboardOrderSchoolCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c25720",
  null
  
)

export default component.exports